import { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { getRepository } from './data/repository';

export default function App() {
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    getRepository().checkAuth().finally(() => {
      setChecking(false);
    });
  }, []);

  if (checking) {
    return (
      <div className="flex h-dvh w-full items-center justify-center bg-[var(--mfv-page-bg)]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[var(--mfv-gold)]"></div>
      </div>
    );
  }

  return <RouterProvider router={router} />;
}